import React from "react";
import { useTranslation } from "react-i18next";
import { useRevalidator } from "react-router";
import Button from "../Button/Button";
import RefreshIcon from "@mui/icons-material/Refresh";

export default function RetryButton(): React.ReactNode {
  const { t } = useTranslation();
  const { revalidate, state } = useRevalidator();

  return (
    <Button
      variant="contained"
      size="large"
      disableElevation
      loading={state === "loading"}
      startIcon={<RefreshIcon />}
      onClick={() => void revalidate()}
      sx={{ width: "100%", py: 1.5, borderRadius: 1, fontWeight: 600 }}
    >
      {t("button.try_again")}
    </Button>
  );
}
